// src/icons/CheckmarkCircleTier3.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function CheckmarkCircleTier3() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 28 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "14", cy: "14", r: "14", fill: "white" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M8 13.9752L11.644 17.6192C11.644 17.6192 15.8995 13.3636 19.2631 10",
            stroke: "#0048F7",
            strokeWidth: "2"
          }
        )
      ]
    }
  );
}

export {
  CheckmarkCircleTier3
};
